<script>
    import { navigateTo } from 'svelte-router-spa'
    import { addQuestions, addQuestionsAns } from '../../store.js'

    let questions = JSON.parse($addQuestions)
    
    let currentIndex = 0
    let currentQuestion = questions[currentIndex]
    let myAnswers = [], textAnswer, multiAnswers = []
    function nxt(answer) {
        if (Array.isArray(answer)) {
            answer = ""
            multiAnswers.forEach(function (item) {
                answer += item + " "
            })
        }
        myAnswers.push({
            q: currentQuestion.e,
            a: answer
        })
        if (currentIndex === questions.length - 1) {
            console.log(myAnswers)
            addQuestionsAns.set(JSON.stringify(myAnswers))
            navigateTo('result')
        } else {
            currentIndex += 1
            currentQuestion = questions[currentIndex]
        }
        textAnswer = ""
        multiAnswers = []
    }

</script>

<main>
    <div class="body">
    <h1>{currentQuestion.e}</h1>
    <p>{currentQuestion.f}</p>

    {#if currentQuestion.ansType === "choice"}
        {#each currentQuestion.choices as choice}
        <a class="btn" on:click={() => nxt(choice.val)}>
            <span class="e">{choice.e}</span>
            {#if choice.f}
            <span class="f">{choice.f}</span>
            {/if}
        </a> 
        {/each}
    {/if}

    {#if currentQuestion.ansType === "text"}
    <textarea bind:value={textAnswer} rows="3"></textarea>
    <a class="btn btn-primary" on:click={() => nxt(textAnswer)}>Next</a>
    {/if}

    {#if currentQuestion.ansType === "multi_choice"}
        <ul>
        {#each currentQuestion.choices as choice}
            <li>
                <label for={choice}>
                    <input type="checkbox" id={choice} bind:group={multiAnswers} value={choice}>
                    {choice}
                </label>
            </li>
        {/each}
        </ul>
        {#if multiAnswers.length > 0}
        <a class="btn btn-primary" on:click={() => nxt(multiAnswers)}>Next</a>
        {/if}
    {/if}

    {#if currentQuestion.skippable}
    <a class="btn" on:click={() => nxt("SKIPPED")}>Skip</a>
    {/if}
    </div>
</main>

<style>
.btn {
    margin-right: 8px;
}

ul {
    list-style: none;
    list-style-type: none;
    padding: 0;
    margin-top: 36px;
}

li {
    vertical-align: middle;
    margin-left: none;
    font-size: 20px;
    margin-bottom: 18px;
}

label, [type="checkbox"]{
    display: inline-block;
    vertical-align: middle;
}

[type="checkbox"] {
    margin: 0;
    width: 20px;
    height: 18px;
}
</style>